// extracted by mini-css-extract-plugin
export default {"muted":"TeammateStatusLabel-module__muted--HU2ju","success":"TeammateStatusLabel-module__success--Qtm2Q","warning":"TeammateStatusLabel-module__warning--JwJrB"};